import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, Inject, Input, OnInit, Optional, PLATFORM_ID, inject, input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'clever-hotelfilter',
    templateUrl: './hotelfilter.component.html',
    styleUrls: ['./hotelfilter.component.scss'],
    standalone: false
})
export class HotelfilterComponent implements OnInit {
    readonly mode = input<string>(undefined);
    readonly israiltravel = input<boolean>(undefined);
    readonly onlyfilterandhotel = input<boolean>(false);
    @Input() type: string;
    readonly reference = input<string>(undefined);
    readonly realparams = input<ParamFilters>(undefined);
    readonly completion = input<any>(undefined);
    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = false;
    media: string = 'lg';
    btntext: string = '';
    start: string;
    end: string;
    filter: ParamFilters;
    destroyRef = inject(DestroyRef);

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected hotelFilters: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.btntext = this.type === 'hotelonly' ? 'HOTEL FINDEN' : 'URLAUB FINDEN';
        this.cdr.detectChanges();
        this.initFilters();
        this.initFilterSub();
        this.initMedia();
        this.initMobileExtra();
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    gotoZiel(gotourl): void {
        this.smallVersion = false;
        this.hotelFilters.setIsReilTravel(this.type === 'railtravel');
        this.hotelFilters.setReference(this.reference());
        if (gotourl) {
            this.hotelFilters.gotoUrl(this.type);
        } else {
            this.hotelFilters.changeUrlByType(this.type);
        }
    }

    initFilterSub(): void {
        this.hotelFilters.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            this.filter = JSON.parse(JSON.stringify(filter));
            this.initDate(filter);
            this.cdr.detectChanges();
        });
    }

    async setBahn() {
        this.type = 'railtravel';
        this.hotelFilters.onlySetProductType('railtravel');
    }

    async setPauschal() {
        this.type = 'pauschal';
        this.hotelFilters.onlySetProductType('pauschal');
    }

    async setHotelonly() {
        this.type = 'hotelonly';
        this.hotelFilters.onlySetProductType('hotelonly');
    }

    async initDate(filter) {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start = moment().add(tmp[0], 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD');
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            if (moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.start = moment().add(4, 'days').format('YYYY-MM-DD');
                this.end = moment().add(180, 'days').format('YYYY-MM-DD');
            } else {
                this.start = moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD');
                this.end = moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD');
            }
        } else if (!isNaN(Number(filter?.reisezeitraumResult?.start))) {
            this.start = moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
        } else {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }
        this.cdr.detectChanges();
    }

    showMBMenu(): void {
        this.smallVersion = true;
    }

    closeMenu(): void {
        this.smallVersion = false;
    }

    async initMobileExtra() {
        this.hotelFilters.openextrafiltermobile$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((val: boolean) => {
            this.smallVersion = val;
            this.cdr.detectChanges();
        });
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        const realparams = this.realparams();
        if (realparams) {
            this.hotelFilters.onlySetRealParams(realparams);
        } else if (this.mode() === 'home') {
            this.hotelFilters.resetAllExtrasHome();
        }
    }

    async switchTo(productType) {
        this.hotelFilters.setProductType(productType);
    }

    selectValue(ev): void {
        this.hotelFilters.reisezeitraumResult(ev.start, ev.end);
    }

    async resTraveler(ev) {
        this.hotelFilters.reisendeResult(ev);
    }
}
